import { ref } from 'vue';
import { goToLogin } from '../../router';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5041';

const lavadoService = (() => {
  const lavados = ref([
    {
      descripcion: '',
      fecha: new Date(),
      importe: 0,
      cajaId: 0,
    },
  ]);
  const error = ref(null);
  const axios = require('axios');
  
  const instance = axios.create({
    baseURL: API_URL,
  })
  // Interceptor de respuesta para redirigir al login si token expiró
  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        goToLogin();
      }
      return Promise.reject(error);
    }
  );

  // Agregar interceptor para incluir token en las cabeceras
  instance.interceptors.request.use(
    config => {
      const token = localStorage.getItem('jwt-token');
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  const getLavados = async () => {
    try {
      const response = await instance.get('/Lavado');
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };

  const getTipoLavado = async () => {
    try {
      const response = await instance.get('/TipoLavado');
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };

  const getLavadosPendiente = async () => {
    try {
      const response = await instance.get('/Lavado/Pendientes');
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };

  const getTipoVehiculo = async () => {
    try {
      const response = await instance.get('/TipoVehiculo');
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };

  const getLavadosByCaja = async (_cajaid) => {
    try {
      const response = await instance.get(`/Lavado/${_cajaid}/lavados`);
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };

  const getCantidadLavados = async () => {
    return lavados.value.length;
  };

  const getLavadoById = async (id) => {
    try {
      const response = await instance.get(`/Lavado/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };

  const updateChargeLavado = async (data, id) => {
    try {
      const payload = { ...data };
  
      if ('monto' in payload) {
        // Caso: pantalla de cobrar envía solo el nuevo abono
        payload.montoCaja = Number(payload.monto) || 0;
      } else {
        // Caso: pantalla envía totales
        payload.importe = Number(payload.importe);
        payload.importeAbonado = Number(payload.importeAbonado);
        payload.montoCaja = derivarMontoCaja(payload.importe, payload.importeAbonado);
      }
  
      const response = await instance.put(`/Lavado/charge-lavados/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };
  

  const editLavado = async (lavados) => {
    try {
      const payload = { ...lavados };
  
      // Normalizaciones numéricas
      payload.importe = Number(payload.importe);
      payload.importeAbonado = Number(payload.importeAbonado);
  
      // 🔑 Regla para CAJA 
      payload.montoCaja = derivarMontoCaja(payload.importe, payload.importeAbonado);
  
      const response = await instance.put(`/lavado/${payload.id}`, payload);
      return response; // conservar comportamiento original
    } catch (error) {
      console.log(error);
      return null;
    }
  };
  

  const deleteLavado = async (lavadoId) => {
    try {
      const response = await instance.delete(`/Lavado/${lavadoId}`);
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('No se pudo eliminar el lavado.');
    }
  };

  // const addLavado = async (_data) => {
  //   try {
  //     const response = await instance.post('/Lavado', _data.value);
  //     console.log('Response:', response.data);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error:', error);
  //   }
  // };

  const derivarMontoCaja = (importe, importeAbonado) => {
    const total = Number(importe) || 0;
    const abonado = Number(importeAbonado) || 0;
    return abonado > 0 ? abonado : total; // Regla: si hay abonado > 0, entra abonado; si no, entra total
  };

  const addLavado = async (_data) => {
    try {
      const payload = JSON.parse(JSON.stringify(_data?.value || _data));
  
      // Normalizaciones numéricas
      payload.importe = Number(payload.importe);
      payload.importeAbonado = Number(payload.importeAbonado);
  
      // Fecha ISO
      payload.fecha = payload.fecha
        ? new Date(payload.fecha).toISOString()
        : new Date().toISOString();
  
      // IDs numéricos si vienen como string
      if (payload.presupuestoId) payload.presupuestoId = Number(payload.presupuestoId);
      if (payload.servicioId) payload.servicioId = Number(payload.servicioId);
      if (payload.clienteId) payload.clienteId = Number(payload.clienteId);
  
      // 🔑 Regla para CAJA 
      payload.montoCaja = derivarMontoCaja(payload.importe, payload.importeAbonado);
  
      const response = await instance.post('/Lavado', payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      console.error('Error en addLavado:', error?.response?.data || error?.message || error);
      throw error;
    }
  };
  

  return {
    lavados,
    error,
    addLavado,
    getCantidadLavados,
    getLavadosByCaja,
    getTipoLavado,
    getLavadosPendiente, //Nuevo
    getTipoVehiculo,
    getLavados,
    deleteLavado,
    getLavadoById,
    updateChargeLavado, //Nuevo
    editLavado,
    derivarMontoCaja
  };
})();

export default lavadoService;
